"use client";

import { useRef, useEffect } from "react";

export function AlphabetAccordionExclusive({ children }: { children: React.ReactNode }) {
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        let suppressing = false;

        const handleToggle = (e: Event) => {
            if (suppressing) return;
            const target = e.target as HTMLDetailsElement;
            if (target.tagName !== "DETAILS" || !target.open) return;

            suppressing = true;
            for (const details of container.querySelectorAll("details")) {
                if (details !== target && details.open) {
                    details.open = false;
                }
            }
            suppressing = false;
        };

        container.addEventListener("toggle", handleToggle, true);
        return () => container.removeEventListener("toggle", handleToggle, true);
    }, []);

    return <div ref={containerRef}>{children}</div>;
}
